import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allData: false,
  accessKey: localStorage.getItem("accessKey") === "true",
  getUserState: "",
  getUserName: "",
  activeChats: {},
};

const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    toggleData: (state, action) => {
      state.allData = action.payload;
    },
    adminAccessKey: (state, action) => {
      state.accessKey = action.payload;
      localStorage.setItem("accessKey", action.payload);
    },
    storeState: (state, action) => {
      state.getUserState = action.payload;
    },
    setUserName: (state, action) => {
      state.getUserName = action.payload;
    },
    addChatWindow: (state, action) => {
      const { userId, username, message, isMinimized } = action.payload;

      if (!userId) {
        return;
      }

      const existingChat = state.activeChats[userId] || {};
      const nextMinimized =
        typeof isMinimized === "boolean"
          ? isMinimized
          : existingChat.isMinimized !== undefined
            ? message
              ? existingChat.isMinimized
              : false
            : false;

      state.activeChats[userId] = {
        ...existingChat,
        username: username || existingChat.username || "",
        isMinimized: nextMinimized,
        lastMessage: message ?? existingChat.lastMessage ?? null,
      };
    },
    removeChatWindow: (state, action) => {
      delete state.activeChats[action.payload];
    },
    toggleMinimizeChat: (state, action) => {
      const userId = action.payload;

      if (state.activeChats[userId]) {
        state.activeChats[userId].isMinimized = !state.activeChats[userId].isMinimized;
      }
    },
  },
});

export const {
  toggleData,
  adminAccessKey,
  storeState,
  setUserName,
  addChatWindow,
  removeChatWindow,
  toggleMinimizeChat,
} = dataSlice.actions;

export default dataSlice.reducer;
